import { Typography, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../../Survey/components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const contents = [
  'mcg/kg/min、mg/kg/min = 速率 × 體重 × 60 × 總量(cc) / 藥物劑量(mcg 或 mg)',
  'mcg/kg/hr、mg/kg/hr = 速率 × 體重 × 總量(cc) / 藥物劑量(mcg 或 mg)',
  'mg/hr = 速率 × 總量(cc) / 藥物劑量(mg)',
  'mg/min、u/min = 速率 × 60 × 總量(cc) / 藥物劑量(mg 或 u)',
  'gtt = 每小時注射量(ml/hr) / 3',
  'ml/hr = 每分鐘滴數(gtt) × 3',
];

const CautionList = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="藥物計算公式參考" />
      <Box sx={{ width: '98%', margin: '48px auto 50px 25px' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '38px',
              whiteSpace: 'pre',
            }}
          >
            ・ {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default CautionList;
